/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const googleFontFamilyDataSchema = z.object({
	family: z.string(),
	files: z.record(z.string(), z.string()),
})

export type GoogleFontFamilyDataSchema = z.infer<typeof googleFontFamilyDataSchema>
